import { AssetSendTransaction } from "./asset_send_transaction";
import { Cryptocoin } from "@models/asset/cryptocoins/currencies/cryptocoin";
import { StellarSendType } from "@helpers/types";
import { BpSelectOption } from "@modules/core/components/bp-select/bp-select.component";

export class SendTransaction extends AssetSendTransaction<Cryptocoin> {
	private destination_tag: string = "";
	private isExternal: boolean = false;
	public coin_network_id = "";

	// NEEDED FOR STELLAR!!
	private dt_type: StellarSendType = "memo_id";

	public getIsExternal(): boolean {
		return this.isExternal;
	}

	public setIsExternal(b: boolean): void {
		this.isExternal = b;
	}

	public setDestinationTag(tag: string): void {
		this.destination_tag = tag;
	}

	public getDestinationTag(): string {
		return this.destination_tag;
	}

	public setDtType(tag: StellarSendType): void {
		this.dt_type = tag;
	}

	public getDtType(): string {
		return this.dt_type;
	}

	public filter: Cryptocoin = new Cryptocoin();

	public get _destination_tag(): string {
		return this.destination_tag;
	}

	public set _destination_tag(s: string) {
		this.destination_tag = s;
	}

	public displayRecipient(internal: boolean = false, isEmail: boolean = false): string {
		if (internal && isEmail) {
			return this.getRecipient();
		}
		return !this.getDestinationTag() ? this.getRecipient() : `${this.getRecipient()} / ${this.getDestinationTag()}`;
	}

	public static Types: BpSelectOption[] = ["memo_text", "memo_id"].map((dt) => ({
		name: "stellar_" + dt,
		value: dt
	}));

	public get _dt_type(): StellarSendType {
		return this.dt_type;
	}

	public set _dt_type(s: StellarSendType) {
		this.dt_type = s;
	}
}
